import { Entity, Field } from 'typegraph';

import LaunchURL from 'common/entities/LaunchURL';

@Entity({one: "subscriptions", many: "subscriptionsUser"})
export default class Subscription {

	@Field()
	public id: string;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;
	@Field()
	public endDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/userSummary/entities/Subscription.ts